import { doGet, doPost, doPut } from 'hooks/requests';

export const useVividSeatsService = () => {
    const addToken = (data) => doPost(`/vivid-seats/add-token/`, data);
    const getToken = (data) => doGet(`/vivid-seats/get-token/?company_id=${data.companyId}`);
    const updateToken = (data) => doPut(`/vivid-seats/update-token/`, data);

    const getVividSeatsPayments = (companyId) => doPost(`/vivid-seats/sync-payments/`, { company_id: companyId });

    return {
        addToken,
        getToken,
        updateToken,
        getVividSeatsPayments,
    };
};
